import React from 'react';
import SubscriptionTable from '../components/SubscriptionTable';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectUser } from '../../api/auth/authSlice';

const SubscriptionsPage = () => {
  let navigate = useNavigate();
  const user = useSelector(selectUser);
  return (
    <Box p={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <h1>Subscriptions</h1>
        {user?.role === 'admin' && (
          <Button variant="contained" color="primary" onClick={() => navigate('/subscriptions/create')}>
            Create Subscription
          </Button>
        )}
      </Box>
      <SubscriptionTable />
    </Box>
  );
};

export default SubscriptionsPage;
